<template>
  <div class="live">
    <img
      class="live_icon"
      src="../../assets/img/video_close.png"
      alt=""
      @click="liveClose"
    />
    <p class="live_content">敬请期待</p>
  </div>
</template>
<script>
export default {
  methods: {
    liveClose() {
      this.$emit('liveClose')
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/mobile.scss';
.live {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  .live_icon {
    cursor: pointer;
    display: block;
    width: rem(30);
    height: rem(30);
    position: absolute;
    right: rem(20);
    top: rem(20);
    z-index: 9;
  }
  .live_content {
    font-size: rem(20);
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
  }
}
</style>
